<template>
  <div class="row">
    <div class="col">
      <!-- USER -->
      <div >
        <div class="widget">
            <div class="row vertical-align align-items-center">
              <button
                type="button"
                class="btn btn-circle btn-lg btn-primary mr-2"
              >
                <i class="fa fa-user-cog" />
              </button>
                <h4>{{ $t('user') }}</h4>
            </div>
        </div>

        <ul class="list-group list-group-flush bg-white" v-for="(item, index) in user" :key="index">
          <router-link :to='`${item.path}`'>
            <li class="list-group-item text-secondary">
              {{ $t(item.text) }}
            </li>
          </router-link>
        </ul>
      </div>

      <!-- CONSULTS -->
      <div >
        <div class="widget">
          <div class="row vertical-align align-items-center">
            <button
              type="button"
              class="btn btn-circle btn-lg btn-primary mr-2"
            >
              <i class="fa fa-search" />
            </button>
              <h4>{{ $t('consults') }}</h4>
          </div>
        </div>

        <ul class="list-group list-group-flush bg-white" v-for="(item, index) in consults" :key="index">
          <router-link :to='`${item.path}`'>
            <li class="list-group-item text-secondary">
              {{ $t(item.text) }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>

    <div class="col">
      <!-- TEST REGISTER -->
      <div >
        <div class="widget">
          <div class="row vertical-align align-items-center">
            <button
              type="button"
              class="btn btn-circle btn-lg btn-primary mr-2"
            >
              <i class="fa fa-cogs" />
            </button>
              <h4>{{ $t('test_registers') }}</h4>
          </div>
        </div>

        <ul class="list-group list-group-flush bg-white" v-for="(item, index) in testRegister" :key="index">
          <router-link :to='`${item.path}`'>
            <li class="list-group-item text-secondary">
              {{ $t(item.text) }}
            </li>
          </router-link>
        </ul>
      </div>

      <!-- REGISTERS APP FROTIX -->
      <div >
        <div class="widget">
          <div class="row vertical-align align-items-center">
            <button
              type="button"
              class="btn btn-circle btn-lg btn-primary mr-2"
            >
              <i class="fa fa-cogs" />
            </button>
              <h4>{{ $t('registers_app_frotix') }}</h4>
          </div>
        </div>

        <ul class="list-group list-group-flush bg-white" v-for="(item, index) in appFrotixRegisters" :key="index">
          <router-link :to='`${item.path}`'>
            <li class="list-group-item text-secondary">
              {{ $t(item.text) }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>

    <div class="col">
      <!-- STOCK REGISTER -->
      <div >
        <div class="widget">
          <div class="row vertical-align align-items-center">
            <button
              type="button"
              class="btn btn-circle btn-lg btn-primary mr-2"
            >
              <i class="fa fa-cogs" />
            </button>
              <h4>{{ $t('stock_registers') }}</h4>
          </div>
        </div>

        <ul class="list-group list-group-flush bg-white" v-for="(item, index) in stockRegister" :key="index">
          <router-link :to='`${item.path}`'>
            <li class="list-group-item text-secondary">
              {{ $t(item.text) }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>

    <div class="col">
      <!-- PARAMETERS -->
      <div>
        <div class="widget">
          <div class="row vertical-align align-items-center">
            <button
              type="button"
              class="btn btn-circle btn-lg btn-primary mr-2"
            >
              <i class="fa fa-wrench" />
            </button>
              <h4>{{ $t('parameters') }}</h4>
          </div>
        </div>

        <ul class="list-group list-group-flush bg-white" v-for="(item, index) in parameters" :key="index">
          <router-link :to='`${item.path}`'>
            <li class="list-group-item text-secondary">
              {{ $t(item.text) }}
            </li>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  user,
  testRegister,
  stockRegister,
  parameters,
  consults,
  appFrotixRegisters,
} from '@/config/settings'

export default {
  name: 'TestSettingsList',
  data: () => ({
    user: user(),
    testRegister : testRegister(),
    stockRegister: stockRegister(),
    parameters   : parameters(),
    consults     : consults(),
    appFrotixRegisters: appFrotixRegisters(),
  })
}
</script>
